<template>
  	<vuestic-sidebar :hidden="isOpen">

	  	<template slot="menu" v-if="id_role == 8">
			<sidebar-link :to="{ name: 'lista-autoescolas' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"></span>
					<span>Relação de Autoescolas</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'ListaAlunos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-user"></span>
					<span>Alunos</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'RelatorioFinanceiro' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file"></span>
					<span>Relatório Financeiro</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'RelatorioMonitoramento' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Relatório Monitoria</span>
				</span>
			</sidebar-link>
		</template>

	</vuestic-sidebar>
</template>

<script>
import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'
// import VueResource from 'vue-resource'
import urlApi from '@/router/urlApi'

// Vue.use(VueResource)
export default {
  data () {
    return {
      roles: JSON.parse(localStorage.permissions),
      cfc: localStorage.cfc,
      id_role: localStorage.id_role,
      isMobile: false
    }
  },
  name: 'app-sidebar',
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },

  mounted () {
    this.$http.get(urlApi + '/login/autenticate').then(function (data) {
      console.log(data.status)
    })
    if (window.innerWidth <= 991) {
      this.isMobile = true
    }
  },

  methods: {
	  //
  }
}
</script>

<style scoped>
	span {
		font-weight: bold;
	}
</style>
